import { useEffect } from 'react';

// Sets the tab title and <meta name="description"> for the current page.
// No react-helmet dependency needed - CRA is client-rendered, so this is
// just as effective as a <Helmet> for search/social crawlers that execute JS.
const usePageMeta = (title, description) => {
    useEffect(() => {
        document.title = title;

        let meta = document.querySelector('meta[name="description"]');
        if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('name', 'description');
            document.head.appendChild(meta);
        }
        meta.setAttribute('content', description);
    }, [title, description]);
};

export default usePageMeta;
